import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {NavigationHelperService} from '@application/helper/navigation-helper/navigation-helper.service';
import {PreviewMap} from '@presentation/components/creel-tables/preview-map';
import {PreviewType} from '@presentation/pages/textile-data/creel/add/preview-type';
import {OverviewListCreel} from '@presentation/pages/textile-data/creel/overview/overview-list-creel';
import {AssertionUtils, BaseComponent} from '@vdw/angular-component-library';
import {NavigationCreelMappingDisplay} from './navigation-creel-mapping-display.interface';

@Component({
  selector: 'app-creel-mapping-display',
  templateUrl: './creel-mapping-display.component.html',
  styleUrls: ['./creel-mapping-display.component.scss']
})
export class CreelMappingDisplayComponent extends BaseComponent {
  @Input() public creelForm: FormControl<OverviewListCreel>;
  @Input() public canEditCreelMapping = false;
  @Output() public editCreelMapping = new EventEmitter<void>();

  public creelPreviewMap = PreviewMap.THEORETICAL;
  public creelPreviewType = PreviewType.COLOR;

  public get creel(): OverviewListCreel {
    return this.creelForm.value;
  }

  public constructor(private readonly navigationService: NavigationHelperService<NavigationCreelMappingDisplay>) {
    super();

    let emptyObj = {creelPreviewMap: null, creelPreviewType: null};
    let prevData = this.navigationService.getPartialState<NavigationCreelMappingDisplay>(Object.keys(emptyObj));
    if (!AssertionUtils.isNullOrUndefined(prevData)) {
      this.creelPreviewMap = prevData.creelPreviewMap;
      this.creelPreviewType = prevData.creelPreviewType;
    }
  }

  public onNavigationHelperDestroy(): void {
    this.navigationService.savePartialState<NavigationCreelMappingDisplay>({
      creelPreviewMap: this.creelPreviewMap,
      creelPreviewType: this.creelPreviewType
    });
  }

  public isPreviewMapToggled(): boolean {
    return this.creelPreviewMap === PreviewMap.ACTIVE;
  }

  public isPreviewTypeToggled(): boolean {
    return this.creelPreviewType === PreviewType.YARN_TYPE;
  }

  public togglePreviewMap(toggled: boolean): void {
    this.creelPreviewMap = toggled ? PreviewMap.ACTIVE : PreviewMap.THEORETICAL;
  }

  public togglePreviewType(toggled: boolean): void {
    this.creelPreviewType = toggled ? PreviewType.YARN_TYPE : PreviewType.COLOR;
  }
}
